import { message } from "antd"
import { APP_CONFIG } from "../../../../config";

// import { AWS } from "../../services/cloud";
import { TIME } from "../../services/util";

import * as API from '../../services/api'

const { AWS_URI, AWS_SDK_CONFIG } = APP_CONFIG;

// const { uploadS3 } = AWS;

const { getCurrentDateFormat } = TIME;

// const putS3Asset = async (awsKey, { file, onError, onProgress, onSuccess }) => {
//   const { name: filename } = file;
//   try {
//     const data = await uploadS3({
//       bucket: AWS_URI.s3.asset.bucket,
//       key: `${awsKey}/${getCurrentDateFormat()}/${getCurrentDateTimeFormat()}_${filename}`,
//       file,
//     })
//       .on("httpUploadProgress", ({ loaded, total }) => {
//         onProgress(
//           {
//             percent: Math.round((loaded / total) * 100),
//           },
//           file
//         );
//       })
//       .done();

//     onSuccess(data, file);
//   } catch (err) {
//     console.error("Error uploading to S3:", err);
//     onError(err);
//   }
// };

export const decodeFile = (file, decode = () => {}) => {

    const reader = new FileReader();

    reader.onload = (e) => {
        const d = e.target.result;
        decode(d)
    } 

    reader.readAsBinaryString(file)
}


export const getBase64 = (file, cb = () => {}) => {
  const reader = new FileReader();
  reader.addEventListener("load", () => cb(reader.result));
  reader.readAsDataURL(file);
};

const validateFileType = (file) => {
  const fileTypes = [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "video/mp4", 
    "video/avi", 
    "video/x-msvideo",
    "application/pdf",

  ];
  return fileTypes.includes(file.type);
};

export const handleBeforeUpload = (file) => {
    if (!validateFileType(file)) {
        message.error(`File type ${file.type} is not supported.`);
        return false;
    } else {
        return true;
  }
};

export const UploadDriverICImage = ({ file, onError, onSuccess }) => {

    API
    .uploadFile(file, getCurrentDateFormat(), 'driver')
    .then(info => {

        try {
            const { status, data } = info
    
            if(status === 200) {
                onSuccess(data, file)
            }
        } 

        catch(err) {
            onError(err)
        }
    })
    // putS3Asset(AWS_URI.s3.asset.key.driver, data);
    
}

export const UploadReceiptImage = (path, { file, onSuccess, onError }, vehicleTime) => {

    API
    .uploadFileFuelReceipt(`${path}/`, file, vehicleTime)
    .then(info => {

        try {
            const { status, data } = info
    
            if(status === 200) {
                console.log(data)
                onSuccess(data, file)
            }
        } 

        catch(err) {
            onError(err)
        }
    })

    // putS3Asset(AWS_URI.s3.asset.key.driver, data);
    
}

export const UploadVehicleIssueComment = ({ file, onError, onSuccess }) => {
    
    API
    .uploadFile(file, getCurrentDateFormat(), 'vehicle/issue')
    .then(info => {

        try {
            const { status, data } = info
    
            if(status === 200) {
                onSuccess(data, file)
            }
        } 

        catch(err) {
            onError(err)
        }
    })
    // putS3Asset(AWS_URI.s3.asset.key.vehicle_issue, data); 
    
}

export const UploadVehicleIssueImage = ({ file, onError, onSuccess }) => {

    API
    .uploadFile(file, getCurrentDateFormat(), 'vehicle/issue')
    .then(info => {

        try {
            const { status, data } = info
    
            if(status === 200) {
                onSuccess(data, file)
            }
        } 

        catch(err) {
            onError(err)
        }
    })

    // putS3Asset(AWS_URI.s3.asset.key.vehicle_issue, data);
}

export const DeleteImage = (file) => {
    const path = file?.response?.url?.replace(`https://${AWS_URI.s3.asset.bucket}.s3.${AWS_SDK_CONFIG.credential.region}.amazonaws.com/`, "")

    if(!path.includes('https://')) {
        API
        .deleteFile(path)
    }
}